







import { Component, Prop, Vue } from "vue-property-decorator";
import { ButtonVariant } from "@/types";

@Component
export default class Button extends Vue {
  @Prop({ required: true }) text!: string;
  @Prop({ required: true }) variant!: ButtonVariant;
  @Prop({ required: false }) icon?: string;
}
